import React from 'react';

/**
 * Shared All / My Team scope filter for leadership pipeline views.
 * @param {'all'|'my_team'} value
 * @param {(next: 'all'|'my_team') => void} onChange
 */
export default function TeamScopeFilter({ value, onChange, className = '' }) {
  return (
    <div
      className={`inline-flex rounded-[100px] border border-lineGray bg-white p-0.5 text-xs font-semibold ${className}`}
      role="group"
      aria-label="Team scope"
    >
      <button
        type="button"
        onClick={() => onChange('my_team')}
        className={`rounded-[100px] px-3 py-1.5 transition-colors ${
          value === 'my_team' ? 'bg-navy text-white' : 'text-slateText hover:text-navy'
        }`}
      >
        My Team
      </button>
      <button
        type="button"
        onClick={() => onChange('all')}
        className={`rounded-[100px] px-3 py-1.5 transition-colors ${
          value === 'all' ? 'bg-navy text-white' : 'text-slateText hover:text-navy'
        }`}
      >
        All
      </button>
    </div>
  );
}
